import { Component, Input, Output, OnInit, AfterContentInit, OnChanges, SimpleChanges, EventEmitter } from "@angular/core";
import { StringExtensions } from "../../utilities/string.extensions";


@Component({
  selector: "switch-3state",
  template: `<label class="switch">    
    <input [id]="id" type="checkbox" [indeterminate]="isUnchecked" [ngModel]="switchState" (ngModelChange)="checkSwitch(isUnchecked)" [attr.disabled]="disabled? true : null">
    <span class="slider round"></span>    
  </label><br/>`,
  styleUrls: ['./switch-3state.component.css']
})
export class Switch3StateComponent implements OnInit, OnChanges, AfterContentInit {
  @Input() id: string;
  @Input() state: number;
  @Input() disableOn: boolean = false;
  @Input() disableOff: boolean = false;
  @Input() disabled: boolean = false;
  @Output() onChange: EventEmitter<number> = new EventEmitter<number>();
  isUnchecked: boolean = true;
  switchState: boolean = true;

  constructor() { }

  ngOnInit() {
    if (!this.id) { this.id = "switch-3state-" + StringExtensions.generateUUID(); }

    if (this.disableOff) {
      this.switchState = undefined;
    }
    if (this.disableOn && this.disableOff) {            
      this.disabled = true;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
   
  }

  ngAfterContentInit() {
    switch (this.state) {
      case -1:
        this.isUnchecked = false;
        this.switchState = false;
        break;
      case 0:
        this.isUnchecked = true;
        break;
      case 1:
        this.isUnchecked = false;
        this.switchState = true;
        break;
      default:
        this.isUnchecked = true;
    }
  }

  checkSwitch(isUnchecked: boolean) {

    if (isUnchecked) {
      this.switchState = !this.switchState;      
      this.isUnchecked = false;
      this.state = this.switchState ? 1 : -1;
      
      if (this.disableOn) {
        this.switchState = false;
        this.state = -1;
      }
      if (this.disableOff) {
        this.switchState = true;
        this.state = 1;
      }
    }
    else {
      this.isUnchecked = !isUnchecked;
      this.state = 0;
    }

    this.onChange.emit(this.state);
  }
}
